import IpcRouter from '@shared/ipc/IpcRouter.ts'
import type { ShellInfo, ShellSessionId, OpenShellArgs, TmuxStatus } from '@shared/types/ShellTypes'

export interface ShellIpcRouterType {
  listShells: () => Promise<Array<ShellInfo>>
  spawnShell: (args: OpenShellArgs) => Promise<ShellInfo>
  killShell: (id: ShellSessionId) => Promise<boolean>
  openShell: (id: ShellSessionId) => Promise<boolean>
  getTmuxStatus: () => Promise<TmuxStatus>
}

class ShellIpcRouter extends IpcRouter<ShellIpcRouterType> {
  constructor() {
    super('shell', {
      listShells: true,
      spawnShell: true,
      killShell: true,
      openShell: true,
      getTmuxStatus: true,
    })
  }

  async listShells(): Promise<Array<ShellInfo>> {
    return this.exec('listShells')
  }

  async spawnShell(args: OpenShellArgs): Promise<ShellInfo> {
    return this.exec('spawnShell', args)
  }

  async killShell(id: ShellSessionId): Promise<boolean> {
    return this.exec('killShell', id)
  }

  async openShell(id: ShellSessionId): Promise<boolean> {
    return this.exec('openShell', id)
  }

  async getTmuxStatus(): Promise<TmuxStatus> {
    return this.exec('getTmuxStatus')
  }
}

export default ShellIpcRouter
